module.exports = __webpack_public_path__ + "img/côte-d'ivoire.e2ead7af.svg";